import { getRowId } from './getRowId';

// After a reload the grid holds brand-new row objects, but the selection still
// holds the old ones. Aggregate controls match selected rows by object
// reference, so the selection must be swapped to the new objects (paired by
// dataKey — the same id the checkboxes render by).
// - selected row not in data → kept as is (length/ids/order never change)
// - id duplicated in data (page-relative synthetic _id) → kept as is
// - nothing swapped → returns the SAME array, so no extra re-render
export const remapSelectedRowsToData = (
  selectedRows: any[],
  data: any[],
  dataKey: string
): any[] => {
  if (selectedRows.length === 0 || data.length === 0) return selectedRows;

  const freshRowsById = new Map<string, any>();
  const duplicatedIds = new Set<string>();
  data.forEach((row) => {
    const id = getRowId(row, dataKey);
    if (id === null) return;
    if (freshRowsById.has(id)) {
      duplicatedIds.add(id);
      return;
    }
    freshRowsById.set(id, row);
  });

  let changed = false;
  const remapped = selectedRows.map((row) => {
    const id = getRowId(row, dataKey);
    if (id === null || duplicatedIds.has(id)) return row;

    const freshRow = freshRowsById.get(id);
    if (!freshRow || freshRow === row) return row;

    changed = true;
    return freshRow;
  });

  return changed ? remapped : selectedRows;
};
